module.exports = __webpack_public_path__ + "static/media/patmang2.25ffd9a7.png";